export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/icon_play-ede0bf608569dfefffd67d6538724ec8.svg";